import React from 'react';
import { Col } from 'react-bootstrap';
import Skeleton from '../../../common/skeleton';
const DetailGridSkeleton = () => {
  return (
    <>
      <Col className="p-0">
        <div className="account-details-grid" id="pdfdiv">
          <Col className="px-0 mt-4">
            <Skeleton count={8} height={12} className="plan-details-skeleton" />
          </Col>
        </div>
      </Col>
    </>
  );
};

export default DetailGridSkeleton;
